import { render } from "./BlackCatIcon.svg?vue&type=template&id=40b72936"
const script = {}
script.render = render

export default script